"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.labels = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
;
var BirthStatusOptionalContent = /** @class */ (function (_super) {
    __extends(BirthStatusOptionalContent, _super);
    function BirthStatusOptionalContent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: [],
            error: []
        };
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            var _a = _this.props, number = _a.number, optNum = _a.optNum;
            if (_this._isMounted) {
                var state = form_store_1.default.getState();
                _this.setState({
                    value: state.data["birth_status_optional_content_".concat(number)] || [],
                    error: state.error["birth_status_optional_content_".concat(number)] || []
                });
            }
        });
        return _this;
    }
    BirthStatusOptionalContent.prototype.componentDidMount = function () {
        this._isMounted = true;
        var _a = this.props, number = _a.number, optNum = _a.optNum;
        var state = form_store_1.default.getState();
        this.setState({
            value: state.data["birth_status_optional_content_".concat(number)] || [],
            error: state.error["birth_status_optional_content_".concat(number)] || []
        });
    };
    BirthStatusOptionalContent.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    BirthStatusOptionalContent.prototype.render = function () {
        var _a = this.props, number = _a.number, optNum = _a.optNum;
        var _b = this.state, value = _b.value, error = _b.error;
        var errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
        if (error.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "err" }, error[0]));
        }
        var labels = {
            "脳・神経": [
                "無脳症",
                "脳瘤",
                "小頭症",
                "先天性水頭症",
                "脳梁の先天奇形",
                "全前脳(胞)症",
                "先天性脳嚢胞",
                "二分脊椎",
                "アーノルド・キアリ症候群",
                "神経系のその他の先天奇形",
            ],
            "眼、耳、顔面及び頚部": [
                "先天(性)眼瞼下垂",
                "無眼球症",
                "小眼球症",
                "先天性白内障",
                "先天性耳介欠損",
                "外耳道の先天(性)欠損、閉鎖及び狭窄",
                "副耳(介)",
                "小耳症",
                "先天性耳瘻孔と先天性嚢胞",
                "眼、耳、顔面及び頚部のその他の先天奇形",
            ],
            "心臓・循環器": [
                "総動脈幹症",
                "両大血管右室起始症",
                "完全大血管転位症",
                "単心室症",
                "心室中隔欠損症",
                "心房中隔欠損症",
                "房室中隔欠損症",
                "ファロー四徴症",
                "肺動脈弁閉鎖症",
                "肺動脈弁狭窄症",
                "肺動脈弁閉鎖不全症",
                "三尖弁狭窄症",
                "エプスタイン奇形",
                "右心低形成症候群",
                "大動脈弁狭窄症",
                "大動脈弁閉鎖不全症",
                "僧帽弁狭窄症",
                "僧帽弁閉鎖不全症",
                "左心低形成症候群",
                "右胸心",
                "先天性心ブロック",
                "動脈管開存症",
                "大動脈縮窄症",
                "大動脈弁閉鎖症",
                "肺動脈閉鎖症",
                "肺動脈狭窄症",
                "左上大静脈遺残",
                "総肺静脈還流異常症",
                "部分肺静脈還流異常症",
                "脳血管の動静脈奇形",
                "脳実質外血管の動静脈奇形",
                "循環器系のその他の先天奇形",
            ],
            "呼吸器": [
                "鼻の先天奇形",
                "喉頭の先天奇形",
                "先天性嚢胞肺",
                "肺分画症",
                "呼吸器系のその他の先天奇形",
            ],
            "口唇・口蓋": [
                "口蓋裂",
                "口唇裂(一側性)",
                "口唇裂(両側性)",
                "口唇裂(正中部)",
                "口唇口蓋裂(一側性)",
                "口唇口蓋裂(両側性)",
                "口唇口蓋裂(正中部)",
            ],
            "消化器（口腔、食道、胃腸、肛門、膵臓）": [
                "舌小帯短縮症",
                "巨(大)舌症",
                "食道閉鎖（瘻あり）",
                "食道閉鎖（瘻なし）",
                "先天性肥厚性幽門狭窄",
                "先天性食道裂孔ヘルニア",
                "十二指腸の先天欠損、閉鎖及び狭窄",
                "小腸の先天欠損、閉鎖及び狭窄（空腸）",
                "小腸の先天欠損、閉鎖及び狭窄（回腸）",
                "肛門の先天欠損、閉鎖及び狭窄、瘻を伴うもの（瘻あり）",
                "肛門の先天欠損、閉鎖及び狭窄、瘻を伴うもの（瘻なし）",
                "メッケル憩室",
                "ヒルシュスプルング病",
                "腸回転異常及び総腸間膜症",
                "重複腸(管)",
                "総排泄腔遺残",
                "輪状膵",
                "先天性膵嚢胞",
                "消化器系のその他の先天奇形",
            ],
            "生殖器": [
                "先天性卵巣嚢胞",
                "先天性直腸腟瘻",
                "女性性器のその他の先天奇形",
                "停留睾丸(一側性)",
                "停留睾丸(両側性)",
                "尿道下裂",
                "男性生殖器のその他の先天奇形",
                "性不確定",
            ],
            "腎尿路": [
                "腎無発生",
                "腎低形成",
                "ポッター症候群",
                "先天性単一腎嚢胞",
                "多発性嚢胞腎",
                "腎異形成",
                "先天性水腎症",
                "分葉腎、融合腎及び馬蹄腎",
                "先天性巨大尿管(症)",
                "重複尿管",
                "膀胱外反(症)",
                "尿道上裂",
                "先天性後部尿道弁",
                "腎尿路系のその他の先天奇形",
            ],
            "筋骨格・横隔膜・四肢": [
                "頭蓋骨(早期)癒合症",
                "骨系統疾患、長管骨及び脊椎の成長障害を伴うもの",
                "先天性股関節脱臼",
                "内反足",
                "多指症",
                "多趾症",
                "合指＜趾＞症",
                "多合指＜趾＞症",
                "先天性横隔膜ヘルニア",
                "臍帯ヘルニア",
                "腹壁破裂",
                "プルンベリー症候群",
                "筋骨格系のその他の先天奇形",
            ],
            "皮膚": [
                "結節性硬化症",
                "神経線維腫症(非悪性)",
                "皮膚のその他の先天奇形",
            ],
            "その他": [
                "マルファン症候群",
                "内臓逆位",
                "結合双体",
                "多系統に及ぶ先天奇形症候群",
                "ダウン症候群",
                "18トリソミー",
                "13トリソミー",
                "ターナー症候群",
                "クラインフェルター症候群",
                "その他の染色体異常",
            ],
        };
        var elems = Object.keys(labels).map(function (label, i) { return (react_1.default.createElement("div", { className: (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          display: grid;\n          gap: 10px;\n          grid-template-columns: 2fr 5fr;\n          margin: 20px 0;\n        "], ["\n          display: grid;\n          gap: 10px;\n          grid-template-columns: 2fr 5fr;\n          margin: 20px 0;\n        "]))), key: i },
            react_1.default.createElement("div", { className: (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            font-size: 14px;\n            font-weight: 700;\n          "], ["\n            font-size: 14px;\n            font-weight: 700;\n          "]))) }, label),
            react_1.default.createElement("div", { className: (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            display: flex;\n            flex-wrap: wrap;\n            gap: 5px;\n          "], ["\n            display: flex;\n            flex-wrap: wrap;\n            gap: 5px;\n          "]))) }, labels[label].map(function (item, j) { return (react_1.default.createElement("label", { className: (0, css_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                background-color: white;\n                border-radius: 3px;\n                padding: 3px 5px;\n              "], ["\n                background-color: white;\n                border-radius: 3px;\n                padding: 3px 5px;\n              "]))), key: j },
                react_1.default.createElement("input", { className: (0, css_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                  margin-right: 5px;\n                "], ["\n                  margin-right: 5px;\n                "]))), type: "checkbox", name: "birth_status_optional_content_".concat(number), value: "".concat(item), checked: value.indexOf("".concat(item)) > -1, onChange: input_actions_1.default.changeInput }),
                item)); })))); });
        return (react_1.default.createElement("div", { className: "form__inner--field" },
            errorElem,
            react_1.default.createElement("div", { className: "form__inner--input" }, elems)));
    };
    return BirthStatusOptionalContent;
}(react_1.Component));
exports.default = BirthStatusOptionalContent;
exports.labels = {
    "脳・神経": [
        "無脳症",
        "脳瘤",
        "小頭症",
        "先天性水頭症",
        "脳梁の先天奇形",
        "全前脳(胞)症",
        "先天性脳嚢胞",
        "二分脊椎",
        "アーノルド・キアリ症候群",
        "神経系のその他の先天奇形",
    ],
    "眼、耳、顔面及び頚部": [
        "先天(性)眼瞼下垂",
        "無眼球症",
        "小眼球症",
        "先天性白内障",
        "先天性耳介欠損",
        "外耳道の先天(性)欠損、閉鎖及び狭窄",
        "副耳(介)",
        "小耳症",
        "先天性耳瘻孔と先天性嚢胞",
        "眼、耳、顔面及び頚部のその他の先天奇形",
    ],
    "心臓・循環器": [
        "総動脈幹症",
        "両大血管右室起始症",
        "完全大血管転位症",
        "単心室症",
        "心室中隔欠損症",
        "心房中隔欠損症",
        "房室中隔欠損症",
        "ファロー四徴症",
        "肺動脈弁閉鎖症",
        "肺動脈弁狭窄症",
        "肺動脈弁閉鎖不全症",
        "三尖弁狭窄症",
        "エプスタイン奇形",
        "右心低形成症候群",
        "大動脈弁狭窄症",
        "大動脈弁閉鎖不全症",
        "僧帽弁狭窄症",
        "僧帽弁閉鎖不全症",
        "左心低形成症候群",
        "右胸心",
        "先天性心ブロック",
        "動脈管開存症",
        "大動脈縮窄症",
        "大動脈弁閉鎖症",
        "肺動脈閉鎖症",
        "肺動脈狭窄症",
        "左上大静脈遺残",
        "総肺静脈還流異常症",
        "部分肺静脈還流異常症",
        "脳血管の動静脈奇形",
        "脳実質外血管の動静脈奇形",
        "循環器系のその他の先天奇形",
    ],
    "呼吸器": [
        "鼻の先天奇形",
        "喉頭の先天奇形",
        "先天性嚢胞肺",
        "肺分画症",
        "呼吸器系のその他の先天奇形",
    ],
    "口唇・口蓋": [
        "口蓋裂",
        "口唇裂(一側性)",
        "口唇裂(両側性)",
        "口唇裂(正中部)",
        "口唇口蓋裂(一側性)",
        "口唇口蓋裂(両側性)",
        "口唇口蓋裂(正中部)",
    ],
    "消化器（口腔、食道、胃腸、肛門、膵臓）": [
        "舌小帯短縮症",
        "巨(大)舌症",
        "食道閉鎖（瘻あり）",
        "食道閉鎖（瘻なし）",
        "先天性肥厚性幽門狭窄",
        "先天性食道裂孔ヘルニア",
        "十二指腸の先天欠損、閉鎖及び狭窄",
        "小腸の先天欠損、閉鎖及び狭窄（空腸）",
        "小腸の先天欠損、閉鎖及び狭窄（回腸）",
        "肛門の先天欠損、閉鎖及び狭窄、瘻を伴うもの（瘻あり）",
        "肛門の先天欠損、閉鎖及び狭窄、瘻を伴うもの（瘻なし）",
        "メッケル憩室",
        "ヒルシュスプルング病",
        "腸回転異常及び総腸間膜症",
        "重複腸(管)",
        "総排泄腔遺残",
        "輪状膵",
        "先天性膵嚢胞",
        "消化器系のその他の先天奇形",
    ],
    "生殖器": [
        "先天性卵巣嚢胞",
        "先天性直腸腟瘻",
        "女性性器のその他の先天奇形",
        "停留睾丸(一側性)",
        "停留睾丸(両側性)",
        "尿道下裂",
        "男性生殖器のその他の先天奇形",
        "性不確定",
    ],
    "腎尿路": [
        "腎無発生",
        "腎低形成",
        "ポッター症候群",
        "先天性単一腎嚢胞",
        "多発性嚢胞腎",
        "腎異形成",
        "先天性水腎症",
        "分葉腎、融合腎及び馬蹄腎",
        "先天性巨大尿管(症)",
        "重複尿管",
        "膀胱外反(症)",
        "尿道上裂",
        "先天性後部尿道弁",
        "腎尿路系のその他の先天奇形",
    ],
    "筋骨格・横隔膜・四肢": [
        "頭蓋骨(早期)癒合症",
        "骨系統疾患、長管骨及び脊椎の成長障害を伴うもの",
        "先天性股関節脱臼",
        "内反足",
        "多指症",
        "多趾症",
        "合指＜趾＞症",
        "多合指＜趾＞症",
        "先天性横隔膜ヘルニア",
        "臍帯ヘルニア",
        "腹壁破裂",
        "プルンベリー症候群",
        "筋骨格系のその他の先天奇形",
    ],
    "皮膚": [
        "結節性硬化症",
        "神経線維腫症(非悪性)",
        "皮膚のその他の先天奇形",
    ],
    "その他": [
        "マルファン症候群",
        "内臓逆位",
        "結合双体",
        "多系統に及ぶ先天奇形症候群",
        "ダウン症候群",
        "18トリソミー",
        "13トリソミー",
        "ターナー症候群",
        "クラインフェルター症候群",
        "その他の染色体異常",
    ],
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
